var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: {
        "bouncing-loader": true,
        inline: _vm.inline,
        overlay: _vm.overlay
      }
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "dots" }, [_c("div"), _c("div"), _c("div")])
  }
]
render._withStripped = true

export { render, staticRenderFns }